module.exports = __webpack_public_path__ + "img/793f4ab.jpg";